import moment from 'moment';

export const payloadRegisterAdapter = (payload) => {
  const formatDate = moment(payload.birthDate, "DD/MM/YYYY").format();

  const { experienceLevel, occupationDetail, ...payloadFields } = payload

  return  { 
    ...payloadFields, 
    cpf: payload.cpf.replace(/\.|-/gm,''),
    birthDate: formatDate,
    login: {
      email: payload.email,
      password: payload.password,
      confirmPassword: payload.confirmPassword
    },
    contact: {
      cel: payload.cel.replace(/[^0-9]+/g, ""),
    },
    agreements: {
      register: payload.register,
      receiveCommunication: payload.receiveCommunication
    },
    cep: payload.cep.replace("-", ""),
    cnpj: payload.personType === 'PJ' ? payload.cnpj.replace(/[^\d]+/g,'') : null,
    corporateName:  payload.personType === 'PJ' ? payload.corporateName : null,
    occupation: {
      occupation: payload.otherOccupation ? "" : payload.occupation,
      otherOccupation: payload.occupation === "Outros" ? payload.otherOccupation : "",
      occupationDetail: payload.occupation === "Assentador" || payload.occupation === "Azulegista" ? occupationDetail : "",
      experienceLevel
    },
    password: undefined,
    confirmPassword: undefined,
    email: undefined,
    cel: undefined,
    register: undefined,
    receiveCommunication: undefined,
    otherOccupation: undefined
  }
}

export const updateUserForm = (user) => {
  const formatDate = moment(user.birthDate).format("DD/MM/yyyy");
  return {
    address: user.address,
    birthDate: formatDate,
    cep: user.cep,
    city: user.city,
    cel: user.contact.cel,
    cpf: user.cpf,
    district: user.district,
    firstName: user.firstName,
    lastName: user.lastName,
    gender: user.gender,
    email: user.login.email,
    number: user.number,
    occupation: user.occupation.occupation.otherOccupation ? "Outros" : user.occupation.occupation.occupation,
    otherOccupation: user.occupation.occupation.otherOccupation,
    occupationDetail:user.occupation.occupation.occupation === "Azulegista" || user.occupation.occupation.occupation === "Assentador" ? user.occupation.occupation.occupationDetail : null,
    experienceLevel: user.occupation.occupation.experienceLevel,
    complement: user.complement,
    state: user.state,
    cnpj: user.cnpj,
    personType: user.personType,
    corporateName: user.corporateName,
    agreements: {
      register: user.register,
      receiveCommunication: user.receiveCommunication
    },
  }
}